import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, SecurityContext, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";

export interface ExternalLinkPopUpDialogData
{
    readonly url: string;
}

@Component({
    selector: "external-link-pop-up-dialog",
    templateUrl: "./externalLinkPopUpDialog.tmpl.html",
    styles: [
        `iframe {
             position: absolute;
             top: 0;
             left: 0;
             width: 100%;
             height: 90%;
         }`
    ],
    imports: [
        CdkScrollable,
        LayoutAlignDirective,
        LayoutDirective,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
    ]
})
export class ExternalLinkPopUpDialogComponent
{
    private readonly data = inject<ExternalLinkPopUpDialogData>(MAT_DIALOG_DATA);
    private readonly domSanitizer = inject(DomSanitizer);


    get url(): string
    {
        return this.domSanitizer.sanitize(SecurityContext.URL, this.data.url);
    }
}
